/* Sticky ATC Bar Variant Picker JavaScript */

(function() {
  'use strict';

  // Función para inicializar el variant picker
  function initStickyVariantPicker(sectionId, products, currentSelection) {
    const pickerElement = document.querySelector(`#sticky-variant-picker-${sectionId}`);
    if (!pickerElement) return;

    const selected = { ...currentSelection };

    // Función para buscar producto coincidente
    function findMatchingProduct() {
      return products.find(p =>
        p.acabado === selected.acabado &&
        p.tamano === selected.tamano &&
        p.configuracion === selected.configuracion &&
        p.diseno === selected.diseno &&
        p.conjunto === selected.conjunto
      );
    }

    // Función para actualizar disponibilidad de opciones
    // Mirrors snippets/pdp-product-variant-picker.liquid availability logic:
    //   hide_disabled → no matching product for combo → hide button (else just mark .disabled)
    //   hide_oos      → matching product exists but is unavailable → hide button
    //   hide_single   → after filtering, group has ≤1 visible option → hide whole group
    function updateAvailability() {
      function applyButtonAvailability(btn) {
        const option = btn.dataset.option;
        const value = btn.dataset.value;
        const group = btn.closest('.sticky-picker-group');
        const hideDisabled = group && group.dataset.hideDisabled === 'true';
        const hideOos = group && group.dataset.hideOos === 'true';

        const testSelection = { ...selected, [option]: value };
        const matchingProduct = products.find(p =>
          (!testSelection.acabado || p.acabado === testSelection.acabado) &&
          (!testSelection.tamano || p.tamano === testSelection.tamano) &&
          (!testSelection.configuracion || p.configuracion === testSelection.configuracion) &&
          (!testSelection.diseno || p.diseno === testSelection.diseno) &&
          (!testSelection.conjunto || p.conjunto === testSelection.conjunto)
        );

        const hasMatch = !!matchingProduct;
        const isOos = hasMatch && matchingProduct.available === false;

        // Reset to baseline before applying flags
        btn.classList.remove('disabled');
        btn.disabled = false;
        btn.style.display = '';

        if (!hasMatch) {
          btn.classList.add('disabled');
          btn.disabled = true;
          if (hideDisabled) {
            btn.style.display = 'none';
          }
        } else if (isOos && hideOos) {
          btn.style.display = 'none';
        }
      }

      // Acabado swatches (inline desktop + mobile renderings inside picker element)
      pickerElement.querySelectorAll('.sticky-swatch-btn').forEach(applyButtonAvailability);

      // Tamaño / configuración / diseño / conjunto desktop buttons
      pickerElement.querySelectorAll('.sticky-option-btn').forEach(applyButtonAvailability);

      // hide_single — recompute after per-button filtering, across both button types
      pickerElement.querySelectorAll('[data-hide-single="true"]').forEach(group => {
        const btns = Array.from(group.querySelectorAll('.sticky-option-btn, .sticky-swatch-btn'));
        const visibleCount = btns.filter(b => b.style.display !== 'none').length;
        group.style.display = visibleCount <= 1 ? 'none' : '';
      });

      // Mobile selects — preserve existing behavior (disabled marking based on hasMatch only)
      pickerElement.querySelectorAll('.sticky-select').forEach(select => {
        const option = select.dataset.option;

        Array.from(select.options).forEach(optionElement => {
          const value = optionElement.value;
          const testSelection = { ...selected, [option]: value };
          const hasMatch = products.some(p =>
            (!testSelection.acabado || p.acabado === testSelection.acabado) &&
            (!testSelection.tamano || p.tamano === testSelection.tamano) &&
            (!testSelection.configuracion || p.configuracion === testSelection.configuracion) &&
            (!testSelection.diseno || p.diseno === testSelection.diseno) &&
            (!testSelection.conjunto || p.conjunto === testSelection.conjunto)
          );

          optionElement.disabled = !hasMatch;
        });
      });
    }

    // Función para navegar al producto
    function navigateToProduct(value) {
      selected.acabado = value;

      console.log('Sticky bar - Selección actual:', selected);

      // Actualizar disponibilidad de otras opciones
      updateAvailability();

      // Buscar producto coincidente
      const match = findMatchingProduct();

      if (match) {
        console.log('Sticky bar - Producto encontrado:', match);
        // Redirigir al producto coincidente si es diferente al actual
        if (match.handle !== currentSelection.currentHandle) {
          window.location.href = `/products/${match.handle}`;
        }
      } else {
        console.log('Sticky bar - No se encontró producto con esta combinación');
      }
    }

    // Escuchar clics en los botones de swatches
    document.querySelectorAll('.sticky-swatch-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const option = this.dataset.option;
        const value = this.dataset.value;

        // Marcar como activo
        const selector = `#sticky-variant-picker-${sectionId} .sticky-swatch-btn[data-option="${option}"]`;
        document.querySelectorAll(selector).forEach(b => {
          b.classList.remove('active');
        });
        this.classList.add('active');

        // Navegar al producto
        navigateToProduct(value);
      });
    });

    // Manejar el botón "Show More"
    const showMoreBtn = document.querySelector('.sticky-show-more-btn');
    const dropdown = document.querySelector('.sticky-swatches-dropdown');

    if (showMoreBtn && dropdown) {
      showMoreBtn.addEventListener('click', function(e) {
        console.log('Sticky bar - Botón "Show More" clicado');
        console.log('dropdown', dropdown);
        e.preventDefault();
        e.stopPropagation();
        dropdown.classList.toggle('active');
      });

      // Cerrar dropdown al hacer clic fuera
      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target) && !showMoreBtn.contains(e.target)) {
          dropdown.classList.remove('active');
        }
      });

      // Manejar clics en los swatches del dropdown
      dropdown.querySelectorAll('.sticky-swatch-btn').forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          const value = this.dataset.value;

          // Marcar como activo en el dropdown
          dropdown.querySelectorAll('.sticky-swatch-btn').forEach(b => {
            b.classList.remove('active');
          });
          this.classList.add('active');

          // Marcar como activo en los swatches visibles
          pickerElement.querySelectorAll('.sticky-options .sticky-swatch-btn').forEach(b => {
            if (b.dataset.value === value) {
              b.classList.add('active');
            } else {
              b.classList.remove('active');
            }
          });

          // Cerrar dropdown
          dropdown.classList.remove('active');

          // Navegar al producto
          navigateToProduct(value);
        });
      });
    }

    // Escuchar clics en los botones de opciones (desktop)
    pickerElement.querySelectorAll('.sticky-option-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const option = this.dataset.option;
        const value = this.dataset.value;

        // Marcar como activo
        const selector = `#sticky-variant-picker-${sectionId} .sticky-option-btn[data-option="${option}"]`;
        document.querySelectorAll(selector).forEach(b => {
          b.classList.remove('active');
        });
        this.classList.add('active');

        // Actualizar el label con el valor seleccionado
        const pickerGroup = this.closest('.sticky-picker-group');
        const currentValueSpan = pickerGroup.querySelector('.sticky-current-value');
        if (currentValueSpan) {
          currentValueSpan.textContent = value;
        }

        // Actualizar selección
        selected[option] = value;

        console.log('Sticky bar - Selección actual:', selected);

        // Actualizar disponibilidad de otras opciones
        updateAvailability();

        // Buscar producto coincidente
        const match = findMatchingProduct();

        if (match) {
          console.log('Sticky bar - Producto encontrado:', match);
          // Redirigir al producto coincidente si es diferente al actual
          if (match.handle !== currentSelection.currentHandle) {
            window.location.href = `/products/${match.handle}`;
          }
        } else {
          console.log('Sticky bar - No se encontró producto con esta combinación');
        }
      });
    });

    // Escuchar cambios en los selectores (tamaño, configuración, diseño, conjunto) - mobile
    document.querySelectorAll('.sticky-select').forEach(select => {
      select.addEventListener('change', function(e) {
        const option = this.dataset.option;
        const value = this.value;

        // Actualizar selección
        selected[option] = value;

        console.log('Sticky bar - Selección actual:', selected);

        // Actualizar disponibilidad de otras opciones
        updateAvailability();

        // Buscar producto coincidente
        const match = findMatchingProduct();

        if (match) {
          console.log('Sticky bar - Producto encontrado:', match);
          // Redirigir al producto coincidente si es diferente al actual
          if (match.handle !== currentSelection.currentHandle) {
            window.location.href = `/products/${match.handle}`;
          }
        } else {
          console.log('Sticky bar - No se encontró producto con esta combinación');
        }
      });
    });

    // Inicializar disponibilidad al cargar
    updateAvailability();
  }

  // Exponer la función globalmente para que pueda ser llamada desde Liquid
  window.initStickyVariantPicker = initStickyVariantPicker;
})();
